export type DeclinationCases =
  /** Mianownik */
  | 'nominative'
  /** Dopełniacz */
  | 'genitive'
  /** Celownik */
  | 'dative'
  /** Biernik */
  | 'accusative'
  /** Narzędnik */
  | 'instrumental'
  /** Miejscownik */
  | 'locative';

export function translateShortCaseToTitle(shortCase: string): DeclinationCases {
  switch (shortCase) {
    case 'D':
      return 'genitive';
    case 'C':
      return 'dative';
    case 'B':
      return 'accusative';
    case 'N':
      return 'instrumental';
    case 'Msc':
      return 'locative';
    case 'M':
    default:
      return 'nominative';
  }
}
